const BLOG_MOBILE_MAX_WIDTH = 820;

function isBlogMobileViewport() {
  return window.innerWidth <= BLOG_MOBILE_MAX_WIDTH;
}

function setBlogSwiperCursor(swiperElement, clientX) {
  const bounds = swiperElement.getBoundingClientRect();
  const midpoint = bounds.left + (bounds.width / 2);
  const isLeftZone = clientX < midpoint;

  swiperElement.style.cursor = isLeftZone ? 'w-resize' : 'e-resize';
}

function initBlogPostSwiper(container) {
  if (!container || container.dataset.swiperReady === 'true') return;
  if (typeof Swiper === 'undefined') return;
  if (container.querySelectorAll('.swiper-slide').length <= 1) return;

  const swiperInstance = new Swiper(container, {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 400,
    grabCursor: false,
    allowTouchMove: true,
    watchOverflow: true,
    loop: true,
    breakpoints: {
      [BLOG_MOBILE_MAX_WIDTH + 1]: {
        allowTouchMove: false
      }
    }
  });

  container.addEventListener('mousemove', (event) => {
    if (isBlogMobileViewport()) return;
    setBlogSwiperCursor(container, event.clientX);
  });

  container.addEventListener('mouseenter', (event) => {
    if (isBlogMobileViewport()) return;
    setBlogSwiperCursor(container, event.clientX);
  });

  container.addEventListener('mouseleave', () => {
    container.style.cursor = '';
  });

  container.addEventListener('click', (event) => {
    if (isBlogMobileViewport()) return;

    const bounds = container.getBoundingClientRect();
    const clickX = event.clientX - bounds.left;
    const isLeftZone = clickX < (bounds.width / 2);

    if (isLeftZone) {
      swiperInstance.slidePrev();
      return;
    }

    swiperInstance.slideNext();
  });

  container.swiperInstance = swiperInstance;
  container.dataset.swiperReady = 'true';
}

function initAllBlogPostSwipers() {
  if (typeof Swiper === 'undefined') return;
  const swipers = document.querySelectorAll('[data-blog-post-swiper]');
  swipers.forEach(initBlogPostSwiper);
}

function initBlogPostReadMore() {
  const posts = document.querySelectorAll('[data-blog-post]');
  if (!posts.length) return;

  const isMobile = isBlogMobileViewport();

  posts.forEach((post) => {
    const content = post.querySelector('[data-blog-post-content]');
    const toggle = post.querySelector('[data-blog-post-toggle]');
    if (!content || !toggle) return;

    if (!isMobile) {
      content.classList.remove('is-collapsed');
      post.classList.remove('is-expanded');
      content.style.maxHeight = '';
      content.style.overflow = '';
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Read more';
      return;
    }

    const computed = window.getComputedStyle(content);
    const lineHeight = parseFloat(computed.lineHeight);
    if (!lineHeight || Number.isNaN(lineHeight)) return;
    const clampHeight = lineHeight * 6;
    post.dataset.blogClampHeight = String(clampHeight);
    const needsToggle = content.scrollHeight > clampHeight + 1;

    if (!needsToggle) {
      content.classList.remove('is-collapsed');
      post.classList.remove('is-expanded');
      content.style.maxHeight = '';
      content.style.overflow = '';
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Read more';
      return;
    }

    toggle.hidden = false;

    if (!post.classList.contains('is-expanded')) {
      content.classList.add('is-collapsed');
      content.style.maxHeight = `${clampHeight}px`;
      content.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Read more';
    } else {
      content.classList.remove('is-collapsed');
      content.style.maxHeight = '';
      content.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'true');
      toggle.textContent = 'Close';
    }
  });
}

function bindBlogPostReadMoreToggle() {
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-blog-post-toggle]');
    if (!toggle) return;
    const post = toggle.closest('[data-blog-post]');
    if (!post) return;
    const content = post.querySelector('[data-blog-post-content]');
    if (!content) return;

    const nextExpanded = !post.classList.contains('is-expanded');
    const clampHeight = Number(post.dataset.blogClampHeight || 0);
    post.classList.toggle('is-expanded', nextExpanded);
    content.classList.toggle('is-collapsed', !nextExpanded);
    if (!nextExpanded && clampHeight > 0) {
      content.style.maxHeight = `${clampHeight}px`;
      content.style.overflow = 'hidden';
    } else {
      content.style.maxHeight = '';
      content.style.overflow = '';
    }
    toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
    toggle.textContent = nextExpanded ? 'Close' : 'Read more';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initAllBlogPostSwipers();
    initBlogPostReadMore();
    bindBlogPostReadMoreToggle();
  }, { once: true });
} else {
  initAllBlogPostSwipers();
  initBlogPostReadMore();
  bindBlogPostReadMoreToggle();
}

document.addEventListener('shopify:section:load', initAllBlogPostSwipers);
document.addEventListener('shopify:section:load', initBlogPostReadMore);
window.addEventListener('load', initAllBlogPostSwipers);
window.addEventListener('load', initBlogPostReadMore);
window.addEventListener('resize', initBlogPostReadMore);
